import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/reset.css';
import {GlobalDrawerProvider} from "./providers/DriverProvider/DriverProvider";
import {SupportWebSocketProvider} from "./providers/SupportWebSocketProvider/SupportWebSocketProvider";
import {Provider} from "react-redux";

import {store} from "./store/store";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <GlobalDrawerProvider>
                <SupportWebSocketProvider>
                    <App/>
                </SupportWebSocketProvider>
            </GlobalDrawerProvider>
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
